var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollList",staticClass:"chat-message-list"},[_vm._l((_vm.messages),function(message,idx){return [_c('Message',{key:idx,attrs:{"message":message},on:{"retry":_vm.handleRetry}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }